import React from 'react';
import { Card, Text, Caption } from '../../design-system';

const T = {
  hand: '"Caveat", "Nunito", cursive',
  sans: '"Nunito", ui-sans-serif, system-ui, -apple-system, sans-serif',
  ink: '#2E2109',
  orange: '#EA7C1F',
};

const SHA_STYLE = {
  fontFamily: '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
  fontSize: '0.78rem',
  color: '#C25F0E',
  background: 'transparent',
  letterSpacing: '0.02em',
};

function formatRelative(iso) {
  if (!iso) return '';
  const ts = new Date(iso).getTime();
  if (Number.isNaN(ts)) return '';
  const diffMs = Date.now() - ts;
  if (diffMs < 0) return 'just now';
  const m = Math.floor(diffMs / 60000);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

export default function RecentCommits({ commits, multiRepo, driftCommitShas }) {
  if (!commits || commits.length === 0) return null;
  const driftSet = driftCommitShas || new Set();
  return (
    <Card>
      <div style={{ padding: 16 }}>
        <div style={{
          fontFamily: '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
          fontSize: 11, fontWeight: 800, letterSpacing: '0.6px',
          textTransform: 'uppercase', color: '#6E5A38',
        }}>
          Recent commits
        </div>
      </div>
      {commits.map((c, i) => {
        const causedDrift = driftSet.has(c.sha);
        return (
          <div
            key={`${c.repo}-${c.sha}-${i}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              padding: '8px 16px',
              borderTop: '1px solid var(--color-border)',
            }}
          >
            {causedDrift && (
              <span style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                background: '#C76A3B', // roof — accent for drift markers
                flexShrink: 0,
              }} />
            )}
            <span style={SHA_STYLE}>{(c.sha || '').slice(0, 7)}</span>
            <Text style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {(c.message || '').split('\n')[0]}
            </Text>
            {multiRepo && <Caption>{c.repo}</Caption>}
            <Caption>{formatRelative(c.timestamp)}</Caption>
          </div>
        );
      })}
    </Card>
  );
}
